<template>
  <nav v-if="length > 0" id="lid-mobile-navigation-breadcrumb" data-component="BreadCrumbs" class="text-sm leading-none">
    <AtomLink
      :url="last(trunkCrumbs).url"
      class="flex items-center text-sm leading-none sm:text-sm md:hidden"
      :class="{ 'text-white breadcrumb-text-shadow': darkModeMobile, 'text-app-lid-blue--prussian': !darkModeMobile }"
    >
      <AtomIconArrowLeft
        class="shrink-0 mr-2 w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"
        :class="{ 'text-white breadcrumb-text-shadow': darkModeMobile, 'text-app-lid-blue--prussian': !darkModeMobile }"
      />
      <span class="underline">{{ last(trunkCrumbs).label }}</span>
    </AtomLink>
    <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="hidden items-center md:flex">
      <li v-for="(crumb, index) in trunkCrumbs" :key="index" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="flex shrink-0 items-center">
        <AtomLink
          itemscope
          itemtype="http://schema.org/Thing"
          itemprop="item"
          :itemid="crumb.url"
          :url="crumb.url"
          class="breadcrumb-link flex shrink-0 items-center underline transform transition duration-200"
        >
          <span itemprop="name">{{ crumb.label }}</span>
        </AtomLink>
        <meta itemprop="position" :content="index" />
        <span class="mx-2 text-white">/</span>
      </li>
      <li>
        <span itemprop="name">{{ leafCrumb.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
interface Props {
  path: Array<{ url: string; label: string }>
  darkModeMobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  darkModeMobile: false,
})

const length = props.path?.length || 0
const last = (list: Array<{ url: string; label: string }>) => list[list.length - 1]

const trunkCrumbs = props.path?.slice(0, length - 1) || []
const leafCrumb = last(props.path)
</script>

<style lang="scss" scoped>
.breadcrumb-text-shadow {
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.3);

  @screen md {
    text-shadow: none;
  }
}

.breadcrumb-link {
  text-underline-offset: 2px;
  text-decoration-color: #002c54;

  &:hover {
    text-decoration-color: white;
  }
}
</style>
